import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import PoolList from '../components/pools/PoolList';

const PoolMonitoringList: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          시설 모니터링
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          모니터링할 시설을 선택
        </Typography>
        
        <Paper sx={{ p: 3, mt: 3 }}>
          <PoolList />
        </Paper>
      </Box>
    </Container>
  );
};

export default PoolMonitoringList; 